import { useEffect, useState } from "react";
import type { TrackSongCode } from "../lib/songCodes";

/** 곡 카드 안의 노래 코드 한 줄 — 코드와 복사 버튼. 영상 수업에서 이 코드로 곡을 가져간다. */
export function SongCodeBox({ songCode }: { songCode: TrackSongCode }) {
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    if (!copied) return;
    const timer = window.setTimeout(() => setCopied(false), 2_000);
    return () => window.clearTimeout(timer);
  }, [copied]);
  return (
    <div className="track-song-code">
      <span>
        <small>이 노래의 곡 코드</small>
        <code>{songCode.code}</code>
      </span>
      <button
        className="button-secondary"
        type="button"
        onClick={() => void navigator.clipboard.writeText(songCode.code).then(() => setCopied(true))}
      >
        {copied ? "복사했어요 ✓" : "복사"}
      </button>
    </div>
  );
}
